import { compose } from '@src/containers/UtmGenerator/helpers/_compose'

export function checkObliqueLine(link, protocol): string {
  const clearDuplicateObliqueLine = link.substring(protocol.length + 3).replace(/\/\/+/g, '/')
  const newLink = `${protocol}://${clearDuplicateObliqueLine}`

  return newLink[newLink.length - 1] === '/' ? newLink.substring(0, newLink.length - 1) : newLink
}

export function deleteProtocol(link): string {
  let updateLink = ''

  link.replace(/https?/, (...match) => {
    updateLink = match[2].substring(match[0].length + 3)
  })

  return updateLink ? updateLink : link
}

export function checkResolveSymbol(value): string {
  function fixedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
      return '%' + c.charCodeAt(0).toString(16)
    })
  }

  function beautifulEncode(str) {
    return str.replace(
      /%../g,
      m =>
        ({
          '%5B': '[',
          '%5D': ']',
          '%7B': '{',
          '%7D': '}'
        }[m] || m)
    )
  }

  return compose(beautifulEncode, fixedEncodeURIComponent)(value)
}
